export default {
  title: {
    welcome: 'Imagem do Bónus de Boas-vindas',
    app_signup: 'Imagem do Bónus de Registo na App Móvel',
  },
  select: {
    generate_title: 'Gerar uma imagem com IA',
    generate_subtitle: 'Criaremos uma com base no seu programa de cashback.',
    generate_cta: 'Gerar',
    upload_link: 'ou carregar do seu dispositivo',
    rate_limit_company: {
      title: 'Precisamos de um momento',
      description: 'O seu restaurante gerou muitas imagens nesta hora. Tente novamente em {{time}}.',
    },
    rate_limit_cashback_bonus: {
      title: 'A recuperar fôlego',
      description: 'Parece que tentou este bónus várias vezes seguidas. Estaremos prontos em {{time}}.',
    },
  },
  generating: {
    title: 'A gerar a sua imagem…',
    progress: {
      cooking: 'A preparar algo saboroso…',
      plating: 'A emplatar…',
      finishing: 'A dar os retoques finais…',
    },
  },
  preview: {
    alt: 'Imagem do bónus gerada',
    hint: 'Não ficou bem? Regere, ou continue para recortar a imagem.',
    click_to_expand: 'Clique para expandir',
    regenerate: 'Regenerar',
    continue: 'Continuar a editar',
  },
  toasts: {
    upload_success: 'Imagem carregada com sucesso.',
    upload_failed: 'Falha ao carregar a imagem.',
    delete_success: 'Imagem eliminada com sucesso.',
    delete_failed: 'Falha ao eliminar a imagem.',
    generate_success: 'Imagem gerada com sucesso.',
    generate_failed: 'Falha ao iniciar a geração da imagem.',
    generate_timeout: 'A imagem ainda está a ser gerada. Aparecerá aqui quando estiver pronta.',
    rate_limit_company: 'Limite horário de imagens atingido para este restaurante. Tente novamente em {{time}}.',
    rate_limit_cashback_bonus: 'Demasiadas tentativas para este bónus agora — tente novamente em {{time}}.',
  },
  time: {
    seconds_one: '1 segundo',
    seconds_other: '{{count}} segundos',
    minutes_one: '1 minuto',
    minutes_other: '{{count}} minutos',
    hours_one: '1 hora',
    hours_other: '{{count}} horas',
  },
};
